// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1RIJU","list":"PatternAutocomplete_list__1bHco"};